export const LOGIN_FORM_CHANGED = "LOGIN_FORM_CHANGED";
export const IS_LOADING = "IS_LOADING";
export const ROLES = "ROLES";
export const LOG_OUT = "LOG_OUT";
export const SET_ANNUAL_LEAVE_POPUP_SHOWN = "SET_ANNUAL_LEAVE_POPUP_SHOWN";
export const AUTHENTICATE_THE_USER_TRUE = "AUTHENTICATE_THE_USER_TRUE";
export const AUTHENTICATE_THE_USER_FALSE = "AUTHENTICATE_THE_USER_FALSE";